import { definePreset, palette } from '@primeng/themes';
import Material from '@primeng/themes/material';
import { ComponentsDesignTokens, Preset } from '@primeng/themes/types';
import { DataTableDesignTokens } from '@primeng/themes/types/datatable';

export const PflegixThemePreset: Preset = definePreset(Material, {
  semantic: {
    primary: palette('#b82f89'),
  },
  component: {
    datatable: {
      row: {
        background: '#22C55E',
        hover: {
          background: '#22C55E',
        },
      },
      body: {
        cell: {
          padding: '0.5rem',
        },
        row: {
          striped: {
            background: '#22C55E',
          },
        },
      },
    } as DataTableDesignTokens,
  } as ComponentsDesignTokens,
});

export const PflegixTheme = {
  preset: PflegixThemePreset,
  options: {
    darkModeSelector: '.app-dark',
    // darkModeSelector: false || 'none',
  },
};
